import React from 'react'
import { Button } from 'react-bootstrap'
import KeyboardIcon from '@material-ui/icons/Keyboard'
import NumPad from 'react-numpad'
import ScannerQR from '../../../Scanner/containers/ScannerQR'
import { COLORES } from '../../../../config/colores'

function EgresoCaladoQRLecturaCamara (props) {
  const { handleSubmit } = props

  return (
    <>
      <NumPad.Number
        className='numpad numpad-grande'
        onChange={(numero) => {
          console.log('Número', numero)
          handleSubmit(numero)
        }}
        decimal={false}
        negative={false}
      >
        <div style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
          <Button
            variant='contained'
            style={{ backgroundColor: COLORES.grey.dark }}
            className='btn-scan-QR btn-ingreso-manual-egreso-qr'
            onClick={() => {}}
          >
            <KeyboardIcon fontSize='large' style={{ color: '#ffffff' }} />

          </Button>
        </div>
      </NumPad.Number>

      <ScannerQR handleSubmit={handleSubmit} />

    </>
  )
}

export default EgresoCaladoQRLecturaCamara
